import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6632924a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spec_list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString($props.item.spec_name) + ":", 1),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.spec_value, (i, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i.spec_value_id,
          onClick: ($event: any) => ($setup.spec_fn(index, i)),
          class: _normalizeClass($setup.colorIndex[$props.item.spec_id] === i.spec_value_id ? 'li_active' : 'noraml')
        }, [
          _createTextVNode(_toDisplayString(i.spec_value_name) + " ", 1),
          ($setup.colorIndex[$props.item.spec_id] === i.spec_value_id)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2))
      }), 128))
    ])
  ]))
}